import z from "zod";

export const createSectorSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  acronym: z.string().min(1, "Sigla é obrigatória"),
  description: z.string().min(1, "Descrição é obrigatória"),
  responsibleId: z.string().min(1, "Responsável é obrigatório"),
  email: z.string().email("Email inválido"),
  phone: z.string().min(1, "Telefone é obrigatório"),
  workingHoursStart: z.string().min(1, "Horário de início é obrigatório"),
  workingHoursEnd: z.string().min(1, "Horário de término é obrigatório"),
  hasRegionals: z.boolean(),
  status: z.enum(["ACTIVE", "INACTIVE"]),
});

export type CreateSectorFormData = z.infer<typeof createSectorSchema>;

export const updateSectorSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  acronym: z.string().min(1, "Sigla é obrigatória"),
  description: z.string().min(1, "Descrição é obrigatória"),
  responsibleId: z.string().optional(),
  email: z.string().email("Email inválido"),
  phone: z.string().min(1, "Telefone é obrigatório"),
  workingHoursStart: z.string().min(1, "Horário de início é obrigatório"),
  workingHoursEnd: z.string().min(1, "Horário de término é obrigatório"),
  hasRegionals: z.boolean(),
  status: z.enum(["ACTIVE", "INACTIVE"]),
});

export type UpdateSectorFormData = z.infer<typeof updateSectorSchema>;
